<template>
      <div class="flex wrap xs-12">
            <div class="xs-8 p0 md-pr10">
                  <!-- Select Product -->
                  <j-card class="xs-12 bg5 r2 p4">
                        <core-form-input
                              componentName="core-select-product"
                              id="products"
                              name="products"
                              :label="$t('product')"
                              v-validate="'required'"
                              v-model="form.products"
                              :validationErrors="errors"
                              size="small"
                              @input="getPrice"
                        />

                        <core-form-input
                              componentName="j-base-input-text"
                              id="startDate"
                              name="startDate"
                              label="Start Date (DD/MM/YYYY)"
                              v-validate="validateStartDate"
                              v-model="form.startDate"
                              :validationErrors="errors"
                              class="mt6"
                              size="small"
                        />
                  </j-card>

                  <!-- Holder -->
                  <j-card class="xs-12 bg5 r2 mt8" v-for="(item, i) in form.holders" :key="item.id">
                        <div class="flex xs-12 xs-between xs-middle p4 bc7 bb1 fs5 fw7 bg1 c5 card-header">
                              <div>Policy Holder {{ i + 1 }}</div>
                              <!-- Remove holder only for not first holder -->
                              <div v-if="i > 0">
                                    <j-button @click="removeHolder(i)" size="xsmall" type="quarternary">
                                          <crm-icon name="delete" size="small" color="cError" />
                                          <span class="cError">Remove this holder</span>
                                    </j-button>
                              </div>
                        </div>
                        <div class="p4">
                              <core-form-input
                                    componentName="j-base-select"
                                    :options="options.salutation"
                                    :id="`holderSalutation${i}`"
                                    :name="`holderSalutation${i}`"
                                    label="Salutation"
                                    v-validate="'required'"
                                    v-model="item.salutation"
                                    :validationErrors="errors"
                                    @blur="
							$validator.validate(
								`holderSalutation${i}`
							)
						"
                                    size="small"
                              />

                              <core-form-input
                                    componentName="j-base-input-text"
                                    :id="`name${i}`"
                                    :name="`name${i}`"
                                    label="Full Name"
                                    description="(English, as shown on HKID Card)"
                                    v-validate="'required'"
                                    v-model="item.name"
                                    :validationErrors="errors"
                                    @blur="$validator.validate(`name${i}`)"
                                    class="mt6"
                                    size="small"
                              />

                              <core-form-input
                                    componentName="j-base-input-text"
                                    :id="`hkid${i}`"
                                    :name="`hkid${i}`"
                                    label="HKID Number"
                                    description="(e.g. A1234563)"
                                    v-validate="'hkid|required'"
                                    v-model="item.hkid"
                                    :validationErrors="errors"
                                    @blur="$validator.validate(`hkid${i}`)"
                                    class="mt6"
                                    size="small"
                              />

                              <core-form-input
                                    componentName="j-base-input-text"
                                    :id="`dateOfBirth${i}`"
                                    :name="`dateOfBirth${i}`"
                                    label="Date of Birth (DD/MM/YYYY)"
                                    description="(Must be 18 years old or above)"
                                    v-validate="validateHolderAge"
                                    v-model="item.dateOfBirth"
                                    :validationErrors="errors"
                                    class="mt6"
                                    size="small"
                                    @blur="
							getPrice()
							$validator.validate(`dateOfBirth${i}`)
						"
                              />

                              <core-form-input
                                    componentName="j-base-input-text"
                                    :id="`address${i}`"
                                    :name="`address${i}`"
                                    label="Correspondence Address"
                                    v-validate="'required'"
                                    v-model="item.address"
                                    :validationErrors="errors"
                                    @blur="$validator.validate(`address${i}`)"
                                    class="mt6"
                                    size="small"
                              />

                              <core-form-input
                                    componentName="j-base-input-text"
                                    :id="`email${i}`"
                                    :name="`email${i}`"
                                    label="Personal Email Address"
                                    v-validate="'email'"
                                    v-model="item.email"
                                    :validationErrors="errors"
                                    @blur="$validator.validate(`email${i}`)"
                                    class="mt6"
                                    size="small"
                              />

                              <!-- Contact for mainholder -->
                              <core-form-input
                                    v-if="i === 0"
                                    componentName="j-base-input-text"
                                    :id="`phone${i}`"
                                    :name="`phone${i}`"
                                    label="Contact Telephone No"
                                    description="(8-digit, e.g. 12345678)"
                                    v-validate="'required'"
                                    @blur="$validator.validate(`phone${i}`)"
                                    v-model="item.phone"
                                    :validationErrors="errors"
                                    class="mt6"
                                    size="small"
                              />
                              <!-- Contact for other holders -->
                              <core-form-input
                                    v-else
                                    componentName="j-base-input-text"
                                    :id="`phone${i}`"
                                    :name="`phone${i}`"
                                    label="Contact Telephone No"
                                    description="(8-digit, e.g. 12345678)"
                                    @blur="$validator.validate(`phone${i}`)"
                                    v-model="item.phone"
                                    :validationErrors="errors"
                                    class="mt6"
                                    size="small"
                              />
                        </div>
                  </j-card>
                  <!-- Add remove holder -->
                  <div class="flex xs-12 xs-right mt2">
                        <j-button @click="addHolder" size="xsmall" type="bordered">
                              <crm-icon name="add" size="small" color="c2" />Add
                              Another Holder
                        </j-button>
                  </div>

                  <!-- Insured -->
                  <j-card class="xs-12 bg5 r2 mt8">
                        <div class="xs-12 p4 bc7 bb1 fs5 fw7 bg1 c5 card-header">Insured Person</div>
                        <div class="p4">
                              <core-form-input
                                    componentName="j-base-toggle"
                                    id="insuredIsTheSame"
                                    name="insuredIsTheSame"
                                    label="Insured Person is the same as First Policy Holder"
                                    v-model="form.insured.isSameAsHolder"
                                    size="small"
                                    @input="getPrice"
                              />

                              <!-- If insured is not the same as holder show full form -->
                              <template v-if="form.insured.isSameAsHolder === false">
                                    <core-form-input
                                          componentName="j-base-select"
                                          :options="options.salutation"
                                          id="insuredSalutation"
                                          name="insuredSalutation"
                                          label="Salutation"
                                          v-validate="'required'"
                                          v-model="form.insured.salutation"
                                          :validationErrors="errors"
                                          size="small"
                                          class="mt6"
                                    />

                                    <core-form-input
                                          componentName="j-base-input-text"
                                          id="insuredName"
                                          name="insuredName"
                                          label="Full Name"
                                          description="(English, as shown on HKID Card)"
                                          v-validate="'required'"
                                          v-model="form.insured.name"
                                          :validationErrors="errors"
                                          class="mt6"
                                          size="small"
                                    />

                                    <core-form-input
                                          componentName="j-base-input-text"
                                          id="insuredHkid"
                                          name="insuredHkid"
                                          label="HKID Number"
                                          description="(e.g. A1234563)"
                                          v-validate="'hkid|required'"
                                          v-model="form.insured.hkid"
                                          :validationErrors="errors"
                                          class="mt6"
                                          size="small"
                                    />

                                    <core-form-input
                                          componentName="j-base-input-text"
                                          id="insuredDateOfBirth"
                                          name="insuredDateOfBirth"
                                          label="Date of Birth"
                                          v-validate="validateInsuredAge"
                                          v-model="form.insured.dateOfBirth"
                                          :validationErrors="errors"
                                          class="mt6"
                                          size="small"
                                          @blur="getPrice"
                                    />
                              </template>

                              <core-form-input
                                    componentName="j-base-radios"
                                    id="insuredGender"
                                    name="insuredGender"
                                    label="Gender"
                                    :options="options.gender"
                                    v-validate="'required'"
                                    v-model="form.insured.gender"
                                    :validationErrors="errors"
                                    class="mt6"
                                    size="small"
                                    @input="getPrice"
                              />

                              <div class="flex wrap xs-12 xs-between mt6">
                                    <div class="xs-12 md-6 pr0 md-pr2">
                                          <core-form-input
                                                componentName="j-base-input-number"
                                                id="insuredHeight"
                                                name="insuredHeight"
                                                label="Height"
                                                description="(in cm, e.g. 169)"
                                                v-validate="'required'"
                                                v-model="form.insured.height"
                                                :validationErrors="errors"
                                                size="small"
                                          />
                                    </div>
                                    <div class="xs-12 md-6 pl0 md-pl2 mt6 md-mt0">
                                          <core-form-input
                                                componentName="j-base-input-number"
                                                id="insuredWeight"
                                                name="insuredWeight"
                                                label="Weight"
                                                description="(in kg, e.g. 60.5)"
                                                v-validate="'required'"
                                                v-model="form.insured.weight"
                                                :validationErrors="errors"
                                                size="small"
                                          />
                                    </div>
                              </div>

                              <div class="flex wrap xs-12 xs-between mt6">
                                    <div class="xs-12 md-6 pr0 md-pr2">
                                          <core-form-input
                                                componentName="j-base-select"
                                                id="insuredOccupation"
                                                name="insuredOccupation"
                                                label="Occupation"
                                                :options="options.occupation"
                                                v-validate="'required'"
                                                v-model="
									form.insured.occupation
								"
                                                :validationErrors="errors"
                                                size="small"
                                          />
                                    </div>
                                    <div class="xs-12 md-6 pl0 md-pl2 mt6 md-mt0">
                                          <core-form-input
                                                v-if="
									form.insured
										.isSameAsHolder ===
										false
								"
                                                componentName="j-base-select"
                                                id="insuredRelationship"
                                                name="insuredRelationship"
                                                label="Relationship to Policy Holder"
                                                :options="options.relationship"
                                                v-validate="'required'"
                                                v-model="
									form.insured.relationship
								"
                                                :validationErrors="errors"
                                                size="small"
                                          />
                                    </div>
                              </div>

                              <div class="flex xs-12 xs-between mt6">
                                    <div class="xs-6">
                                          <core-form-input
                                                componentName="j-base-radios"
                                                id="insuredPlaceOfResidence"
                                                name="insuredPlaceOfResidence"
                                                label="Place of Residence"
                                                :options="[
									{
										name: 'Hong Kong',
										value: 'Hong Kong'
									},
									{
										name: 'Other',
										value: 'other'
									}
								]"
                                                v-validate="'required'"
                                                v-model="
									form.insured
										.placeOfResidenceChoice
								"
                                                :validationErrors="errors"
                                                @input="
									$event === 'Hong Kong'
										? (form.insured.placeOfResidence =
												'Hong Kong')
										: (form.insured.placeOfResidence =
												'')
								"
                                                size="small"
                                          />
                                    </div>
                                    <div class="xs-6">
                                          <core-form-input
                                                v-if="
									form.insured
										.placeOfResidenceChoice ===
										'other'
								"
                                                componentName="j-base-input-text"
                                                id="insuredplaceOfResidenceOther"
                                                name="insuredplaceOfResidenceOther"
                                                label="Please specify"
                                                v-validate="'required'"
                                                v-model="
									form.insured
										.placeOfResidence
								"
                                                :validationErrors="errors"
                                                size="small"
                                          />
                                    </div>
                              </div>
                        </div>
                  </j-card>

                  <j-card class="xs-12 bg5 r2 mt8">
                        <div
                              class="flex xs-12 xs-between xs-middle p4 bc7 bb1 fs5 fw7 bg1 c5 card-header"
                        >Health Statement of the Insured Person</div>
                        <div class="p6">
                              <div class="c1 lh125 fw7 mb2">
                                    Has the proposed Insured Person ever
                                    suffered from, aware of or been treated for
                                    any sickness or any abnormal medical
                                    condition(s)? Please check any that may
                                    apply
                              </div>

                              <!-- Toggle -->
                              <label
                                    :for="item.id"
                                    class="flex xs-12 xs-middle xs-between bg4 bc7 b1 p2 mb1 cu2"
                                    v-for="item in sicknessesSchema"
                                    :key="item.id"
                              >
                                    <div class="xs-10 lh125 fs3">{{ item.label }}</div>
                                    <j-base-toggle
                                          size="small"
                                          :id="item.id"
                                          :value="item.initialValue"
                                          v-model="form.medicalCheckup[item.id]"
                                    />
                              </label>

                              <!-- Other questions -->
                              <core-form-input
                                    componentName="j-base-toggle"
                                    name="hasHospitalTreatmentWithinFiveYears"
                                    label="Has the proposed Insured Person ever been in a hospital or clinic for surgery, observation or treatment within the last 5 years?"
                                    v-model="
							form.medicalCheckup
								.hasHospitalTreatmentWithinFiveYears
						"
                                    size="small"
                                    class="mt6"
                              />

                              <core-form-input
                                    componentName="j-base-toggle"
                                    name="hasUpcomingNeedForMedicalTreatment"
                                    label="Does the proposed Insured Person know any circumstances for which medical treatment may be necessary in the next 12 months?"
                                    v-model="
							form.medicalCheckup
								.hasUpcomingNeedForMedicalTreatment
						"
                                    size="small"
                                    class="mt6"
                              />

                              <core-form-input
                                    componentName="j-base-toggle"
                                    name="hasCurrentNeedForMedication"
                                    label="Is the proposed Insured Person currently under observation or taking any treatment or medication?"
                                    v-model="
							form.medicalCheckup
								.hasCurrentNeedForMedication
						"
                                    size="small"
                                    class="mt6"
                              />

                              <core-form-input
                                    componentName="j-base-toggle"
                                    name="isCurrentlyPregnant"
                                    label="(For female only) Is the proposed Insured Person now pregnant? If YES, please state the stage of pregnancy in terms of months or weeks and declared if there is any complication such as high blood sugar, high blood pressure or other pregnancy related complications."
                                    v-model="
							form.medicalCheckup
								.isCurrentlyPregnant
						"
                                    size="small"
                                    class="mt6"
                              />

                              <core-form-input
                                    componentName="j-base-toggle"
                                    name="hasLostWeightWithinSixMonths"
                                    label="Has the proposed Insured Person ever experienced of losing weight for more than 5 kg within 6 months?"
                                    v-model="
							form.medicalCheckup
								.hasLostWeightWithinSixMonths
						"
                                    size="small"
                                    class="mt6"
                              />

                              <core-form-input
                                    componentName="j-base-toggle"
                                    name="hasCancerDiagnosis"
                                    label="Has the proposed Insured Person’s parents or brother or sister who has ever been diagnosed of cancer before Age 55?"
                                    v-model="
							form.medicalCheckup.hasCancerDiagnosis
						"
                                    size="small"
                                    class="mt6"
                              />

                              <core-form-input
                                    componentName="j-base-toggle"
                                    name="hasFamilyBeenRejectedInsurance"
                                    label="Has the proposed Insured Person or his/her parents or brother or sister ever been refused to cover under any form of life or health insurance or ever had a policy rated, modified or renewal refused?"
                                    v-model="
							form.medicalCheckup
								.hasFamilyBeenRejectedInsurance
						"
                                    size="small"
                                    class="mt6"
                              />
                        </div>
                  </j-card>

                  <!-- Extras -->
                  <j-card class="xs-12 bg5 r2 mt8">
                        <div
                              class="flex xs-12 xs-between xs-middle p4 bc7 bb1 fs5 fw7 bg1 c5 card-header"
                        >Extras</div>
                        <div class="p4">
                              <core-form-input
                                    componentName="j-base-input-text"
                                    name="referralCode"
                                    label="Referral Code"
                                    description="If there is a referral involved, enter an internal code that can be found in Participants corner"
                                    v-model="form.referralCode"
                                    size="small"
                              />
                              <core-form-input
                                    class="mt6"
                                    componentName="j-base-input-text"
                                    name="discountCode"
                                    label="Discount Code"
                                    v-model="form.discountCode"
                                    size="small"
                                    @blur="getPrice"
                              />
                        </div>
                  </j-card>

                  <!-- Buttons -->
                  <div class="xs-12 mt6">
                        <j-button
                              @click="onSubmit"
                              :isLoading="isLoading"
                              :isDisabled="isPriceLoading"
                              action="submit"
                        >Submit</j-button>
                  </div>
            </div>

            <div class="xs-4 p0 md-pl4 mt6 md-mt0">
                  <div class="asia-pricing-box-sticky">
                        <j-card class="xs-12 p4 bg5">
                              <j-spinner v-if="isPriceLoading" />
                              <div class="xs-12 flex wrap mb5" v-for="(item,i) in priceBreakdown" :key="i">
                                    <div class="xs-12 fs3 c6 fw7 mb1">{{item.label}}</div>
                                    <div  
                                          class="xs-12"
                                          :class="{'fw7 fs6':i===priceBreakdown.length-1}"
                                          :data-fup="`component/${item.id}`"
                                    >{{item.value}}</div>
                              </div>
                              <!-- <div class="xs-12 flex xs-right">
																<j-button @click="getPrice" type="bordered" size="xsmall">Refresh</j-button>
                              </div>-->
                        </j-card>
                  </div>
            </div>
      </div>
</template>

<script>
/**
 * TODO: This is hardcoding/hacking application form for Asia Insurance here
 * this should be eventually replaced by new ui config and mapTos thingy
 */
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import JBaseToggle from "@/components/JBaseToggle"
import CrmIcon from "@/components/CrmIcon"
import CoreFormInput from "@/modules/core/components/CoreFormInput.vue"
import JSpinner from "@/components/JSpinner"
import api from "../api/"
import get from "lodash.get"
import dayjs from "dayjs"
import { transformDate } from "@/utils/"
import crmConfig from "@/config/"
// Mocked SDK
import sdk from "../_mockingSdk/"
const getId = () => Math.random()
const holderSchema = {
	id: getId(), // needed for repeated holders
	salutaion: "",
	name: "",
	hkid: "",
	dateOfBirth: null,
	address: "",
	email: "",
	phone: ""
}
// TODO: Populate this based on checkout config
const sicknessesSchema = [
	{
		label: "Cancer or tumour of any kind",
		id: "hasCancer",
		initialValue: false
	},
	{
		label: "Disorder of the skin, bones, glands, eyes or ears",
		id: "hasSkinDisorder",
		initialValue: false
	},
	{
		label: "Asthma or any kind of respiratory disorder",
		id: "hasRespiratoryDisorder",
		initialValue: false
	},
	{
		label: "Deviated nasal septum (or turbinates)",
		id: "hasDeviatedNasalSeptum",
		initialValue: false
	},
	{
		label: "Raised, spat blood, or tuberculosis",
		id: "hasTuberculosis",
		initialValue: false
	},
	{
		label: "Thyroid disorder, Lymph node enlargement",
		id: "hasThyroidDisorder",
		initialValue: false
	},
	{
		label: "Hepatitis or hepatitis carrier",
		id: "hasHepatitis",
		initialValue: false
	},
	{
		label: "Any kind of liver disorder, fatty liver, cirrhosis",
		id: "hasLiverDisorder",
		initialValue: false
	},
	{
		label: "Malaria",
		id: "hasMalaria",
		initialValue: false
	},
	{
		label: "Varicose Veins",
		id: "hasVaricoseVeins",
		initialValue: false
	},
	{
		label: "Fainting, Vertigo",
		id: "hasVertigo",
		initialValue: false
	},
	{
		label: "Epilepsy",
		id: "hasEpilepsy",
		initialValue: false
	},
	{
		label: "Cerebrovascular disorder, stroke, CVA",
		id: "hasCerebrovascularDisorder",
		initialValue: false
	},
	{
		label: "Diabetes",
		id: "hasDiabetes",
		initialValue: false
	},
	{
		label: "Hypertension, hyperlipidemia, hypercholesterolemia",
		id: "hasHypertension",
		initialValue: false
	},
	{
		label: "Chest pain, angina",
		id: "hasChestPain",
		initialValue: false
	},
	{
		label: "Cardiovascular or circulatory disorder",
		id: "hasCardiovascularDisorder",
		initialValue: false
	},
	{
		label: "Any kind of heart disorder, arrhythmias, heart failure",
		id: "hasHeartDisorder",
		initialValue: false
	},
	{
		label: "Ulcer of any kind",
		id: "hasUlcer",
		initialValue: false
	},
	{
		label: "Digestive, esophagus, gastrointestinal tract disorder",
		id: "hasDigestiveEsophagusGastrointestinalTractDisorder",
		initialValue: false
	},
	{
		label: "HaemorrhofieldIds, anal fistulae",
		id: "hasHaemorrhofieldIds",
		initialValue: false
	},
	{
		label: "Hernia",
		id: "hasHernia",
		initialValue: false
	},
	{
		label: "Stone, renal failure or any kind of kidney disorder",
		id: "hasKidneyDisorder",
		initialValue: false
	},
	{
		label: "Hallux Valgus",
		id: "hasHalluxValgus",
		initialValue: false
	},
	{
		label: "Autoimmune disorder",
		id: "hasAutoimmuneDisorder",
		initialValue: false
	},
	{
		label: "Any kind of blood disorder, anemia, thalassemia, leukemia",
		id: "hasBloodDisorder",
		initialValue: false
	},
	{
		label: "Spinal or muscular skeletal conditions/disorder",
		id: "hasSpinalMuscularSkeletalDisorder",
		initialValue: false
	},
	{
		label: "Arthritis, rheumatism, gout",
		id: "hasArthritis",
		initialValue: false
	},
	{
		label: "Breast disorder",
		id: "hasBreastDisorder",
		initialValue: false
	},
	{
		label: "Any kind of gynecological conditions",
		id: "hasGynecologicalConditions",
		initialValue: false
	},
	{
		label: "Disease the Genito-urinary organs",
		id: "hasUrinaryDisease",
		initialValue: false
	},
	{
		label: "Venereal disorder, Syphilis",
		id: "hasVenerealDisorder",
		initialValue: false
	},
	{
		label: "Infection by Human Immunodeficiency Virus (HIV), AIDS",
		id: "hasHivAids",
		initialValue: false
	},
	{
		label:
			"Diseases/ complications or conditions Associated with pregnancy",
		id: "hasPregnancyComplications",
		initialValue: false
	},
	{
		label: "Mental disorder or psychiatric problems",
		id: "hasPsychiatricProblems",
		initialValue: false
	},
	{
		label: "Others (other disorders/ diseases not listed)",
		id: "hasOtherDisorders",
		initialValue: false
	}
]
const options = {
	gender: [
		{
			name: "Male",
			value: "male"
		},
		{
			name: "Female",
			value: "female"
		}
	],
	salutation: [
		{
			name: "Mr.",
			value: "mr"
		},
		{
			name: "Ms.",
			value: "ms"
		},
		{
			name: "Mrs.",
			value: "mrs"
		},
		{
			name: "Miss.",
			value: "miss"
		}
	],
	occupation: [
		{
			name:
				"Student/ Housewife/ Unemployed/ Office worker/ Sales/ Teacher/ People whose work include only office duties/ counter or sales duties",
			value: "001"
		},
		{
			name:
				"Doctor/ Nurse/ Dentist/ Surgeon/ workers in laboratory/ Architect/ supervising construction/ building Contractor/ Immigration Department/ Physiotherapist/ Psychiatrist",
			value: "002"
		},
		{
			name:
				"Blue collar works/ Bus driver/ Taxi driver/ pay driver/ Cook/ Painter/ Waiter/ Waitress",
			value: "003"
		},
		{
			name:
				"Policeman/ Fireman/ Correctional Service Department/ Truck driver/ Stevedore/ Structural Steel Worker/ Furniture Mover/ Carpenter",
			value: "004"
		},
		{
			name:
				"Acrobat/ Jockey/ Professional Sport Players/ Construction site worker",
			value: "005"
		}
	],
	relationship: [
		{
			name: "Spouse",
			value: "spouse"
		},
		{
			name: "Parent",
			value: "parent"
		},
		{
			name: "Grandparents",
			value: "grandparents"
		},
		{
			name: "Children",
			value: "child"
		},
		{
			name: "Siblings",
			value: "sibling"
		}
	]
}
export default {
	components: {
		JCard,
		JButton,
		JBaseToggle,
		CrmIcon,
		CoreFormInput,
		JSpinner
	},
	data() {
		return {
			isPriceLoading: false,
			isLoading: false,
			/**
			 * Payload of the form
			 */
			form: {
				products: [],
				startDate: null,
				holders: [{ ...holderSchema }],
				insured: {
					isSameAsHolder: true,
					salutation: "",
					name: "",
					hkid: "",
					dateOfBirth: null,
					gender: "",
					weight: null,
					height: null,
					placeOfResidenceChoice: "Hong Kong",
					placeOfResidence: "Hong Kong",
					relationship: null,
					occupation: null
				},
				medicalCheckup: {
					hasHospitalTreatmentWithinFiveYears: false,
					hasUpcomingNeedForMedicalTreatment: false,
					hasCurrentNeedForMedication: false,
					isCurrentlyPregnant: false,
					hasLostWeightWithinSixMonths: false,
					hasCancerDiagnosis: false,
					hasFamilyBeenRejectedInsurance: false
				},
				discountCode: null,
				referralCode: null
			},
			// Schema for sicknesses
			sicknessesSchema,
			// Options for the form things
			options,
			// Pricing - object we get from the API
			pricing: {
				formattedOriginalPrice: null,
				formattedPrice: null,
				appliedDiscounts: [],
				appliedTaxes: []
			}
		}
	},
	computed: {
		age() {
			// If insured is first holder, take dateOfBirth from holder[0]
			// Otherwise take it from insured
			if (this.form.insured.isSameAsHolder)
				return this.form.holders[0].dateOfBirth !== ""
					? dayjs().diff(
							transformDate(
								this.form.holders[0].dateOfBirth
							),
							"years"
					  )
					: null
			else
				return this.form.insured.dateOfBirth !== ""
					? dayjs().diff(
							transformDate(
								this.form.insured.dateOfBirth
							),
							"years"
					  )
					: null
		},
		gender() {
			return this.form.insured.gender
		},
		/** Policy Start Date needs to be at least 15 days later than birthday of Insured Person */
		validateStartDate() {
			const insuredDOB = this.form.insured.dateOfBirth
			const transformedDate = transformDate(insuredDOB)
			const targetDate = dayjs(transformedDate)
				.add(14, "day")
				.format("DD/MM/YYYY")
			if (insuredDOB === null)
				return `required|date_format:DD/MM/YYYY`
			else
				return `required|date_format:DD/MM/YYYY|after:${targetDate}`
		},
		/** Holder age can only be 18 - 100 years old
		 *  or if holder is also the insured 18 - 80 years old
		 */
		validateHolderAge() {
			let max, min
			if (this.form.insured.isSameAsHolder === true) {
				// 18 year olds - present date subtract 18 years
				max = dayjs()
					.subtract(18, "year")
					.format("DD/MM/YYYY")
				// 100 year olds - present date subtract 100 years
				min = dayjs()
					.subtract(80, "year")
					.format("DD/MM/YYYY")
			} else {
				// 18 year olds - present date subtract 18 years
				max = dayjs()
					.subtract(18, "year")
					.format("DD/MM/YYYY")
				// 100 year olds - present date subtract 100 years
				min = dayjs()
					.subtract(100, "year")
					.format("DD/MM/YYYY")
			}
			return `required|date_format:DD/MM/YYYY|date_between:${min},${max},inclusion:true`
		},
		/** Insured Age can be 15 days to 80 years old */
		validateInsuredAge() {
			// 15 days olds - present date subtract 15 days
			const max = dayjs()
				.subtract(15, "day")
				.format("DD/MM/YYYY")
			// 80 year olds - present date subtract 80 years
			const min = dayjs()
				.subtract(80, "year")
				.format("DD/MM/YYYY")
			return `required|date_format:DD/MM/YYYY|date_between:${min},${max},inclusion:true`
		},
		/**
		 * What lines to display for price breakdown
		 */
		priceBreakdown() {
			// Combine taxes and discounts together and order based on order
			const appliedDiscounts = this?.pricing?.appliedDiscounts || []	
			const appliedTaxes = this?.pricing?.appliedTaxes || []
			const taxesAndDiscounts = [
				...appliedDiscounts,
				...appliedTaxes
			].sort((a, b) => a.order - b.order)
			const getValue = item => {
				if (!item) return ""
				const ratio = item.ratio ? `${item.ratio * 100}%` : null
				const flat = item.formattedFlat
					? item.formattedFlat
					: null
				return `${flat} (${ratio} of ${item.formattedOriginalPrice})`
			}
			return [
				{
					label: "Gross Premium",
					value: this?.pricing?.formattedOriginalPrice || null
				},
				...taxesAndDiscounts.map(item => ({
					label: item.name ? item.name : item.code,
					value: getValue(item)
				})),
				{
          id: "netPremium",
					label: "Net Premium",
					value: this?.pricing?.formattedPrice
				}
			]
		}
	},
	methods: {
		addHolder() {
			this.form.holders.push({ ...holderSchema, id: getId() })
		},
		removeHolder(index) {
			this.form.holders.splice(index, 1)
		},
		async getPrice() {
			// Call api for price
			this.isPriceLoading = true
			const res = await api.getPrice({
				where: {
					productId: {
						plan: get(
							this,
							"form.products[0].productId.plan"
						),
						type: get(
							this,
							"form.products[0].productId.type"
						),
						version: get(
							this,
							"form.products[0].productId.version"
						)
					}
				},
				discountCodes: [this.form.discountCode].filter(
					item => item
				), // prevent null inside,
				values: this.massageValues()
			})
			this.isPriceLoading = false
			// Save
			this.pricing = get(res, "data.products_2.list[0].pricing", "")
		},
		massageValues() {
			return [
				{
					key: "paymentFrequency",
					value: {
						stringValue: "annual"
					}
				},
				{
					key: "insureds",
					value: {
						arrayValue: [
							{
								objectValue: [
									{
										key: "age",
										value: {
											numberValue: this
												.age
										}
									},
									{
										key: "gender",
										value: {
											stringValue: this
												.gender
										}
									}
								]
							}
						]
					}
				}
			]
		},
		/**
		 * This is a helper function that wll massage payload of the application form
		 * into the shape of SDK object for API's
		 */
		massageFormToSdk() {
			let insured = this.form.insured
			const relationshipsToHolder = []
			if (insured.isSameAsHolder === false)
				relationshipsToHolder.push(insured.relationship)
			else relationshipsToHolder.push("self") // if it's the same person use self
			// Massage holders and other holders
			const holders = this.form.holders.map(holder => ({
				type: "individual",
				credentials: {
					nameFormat: holder.name,
					salutation: holder.salutation,
					dateOfBirth: transformDate(holder.dateOfBirth),
					gender: holder.gender,
					occupation: holder.occupation
				},
				contacts: [
					{ type: "email", value: holder.email },
					{ type: "telephoneNumber", value: holder.phone }
				],
				identities: [{ type: "hkid", value: holder.hkid }],
				addresses: [
					{
						type: "correspondenceAddress",
						fields: [
							{
								type: "correspondenceAddress",
								value: holder.address
							}
						]
					}
				]
			}))
			// If holder is the same as insured,
			// Populate only holder and insured will be empty array
			// If not holder and insured are separate
			if (get(this, "form.insured.isSameAsHolder") === true) {
				holders[0].credentials = {
					nameFormat: this.form.holders[0].name,
					salutation: this.form.holders[0].salutation,
					dateOfBirth: transformDate(
						this.form.holders[0].dateOfBirth
					),
					gender: this.form.insured.gender,
					occupation: this.form.insured.occupation
				}
				holders[0].facts = [
					...Object.keys(this.form.medicalCheckup).map(
						key => ({
							type: key,
							value: this.form.medicalCheckup[key]
						})
					),
					{
						type: "heightInCm",
						value: `${this.form.insured.height}`
					},
					{
						type: "weightInKg",
						value: `${this.form.insured.weight}`
					},
					{
						type: "occupation",
						value: `${this.form.insured.occupation}`
					},
					{
						type: "applicantAcknowledgesDeclaration",
						value: true
					},
					{
						type:
							"applicantUnderstandsCancellationRights",
						value: true
					}
				]
				holders[0].relationshipsToHolder = relationshipsToHolder
				holders[0].addresses.push({
					type: "placeOfResidence",
					fields: [
						{
							type: "address",
							value: insured.placeOfResidence
						}
					]
				})
			}
			const otherHolders = [...holders].slice(1)
			return {
				policyParticulars: {
					productId: get(
						this,
						"form.products[0].productId"
					),
					pricing: {
						grossAmount: this.pricing.originalPrice,
						currencyCode: this.pricing.currencyCode,
						discountCodes: [
							this.form.discountCode
						].filter(item => item) // prevent null inside
					},
					startDate: transformDate(this.form.startDate),
					endDate: dayjs(transformDate(this.form.startDate))
						.add(1, "y")
						.subtract(1, "day")
						.format("YYYY-MM-DD"),
					source: "ADMIN",
					referralCode: this.form.referralCode,
					benefitOptions: [],
					values: this.massageValues()
				},
				isPolicyHolderOneOfInsured: insured.isSameAsHolder,
				policyHolder: { ...holders[0] },
				additionalPolicyHolder: otherHolders,
				insuredPeople: !insured.isSameAsHolder
					? [
							{
								relationshipsToHolder,
								credentials: {
									nameFormat: insured.name,
									salutation:
										insured.salutation,
									dateOfBirth: transformDate(
										insured.dateOfBirth
									),
									gender: insured.gender,
									occupation:
										insured.occupation
								},
								contacts: [],
								identities: [
									{
										type: "hkid",
										value: insured.hkid
									}
								],
								addresses: [
									{
										type:
											"placeOfResidence",
										fields: [
											{
												type:
													"address",
												value:
													insured.placeOfResidence
											}
										]
									}
								],
								facts: [
									...Object.keys(
										this.form
											.medicalCheckup
									).map(key => ({
										type: key,
										value: this.form
											.medicalCheckup[
											key
										]
									})),
									{
										type: "heightInCm",
										value: `${this.form.insured.height}`
									},
									{
										type: "weightInKg",
										value: `${this.form.insured.weight}`
									},
									{
										type: "occupation",
										value: `${this.form.insured.occupation}`
									}
								]
							}
					  ]
					: [],
				insuredObjects: []
			}
		},
		async onSubmit() {
			// If price is loading, return
			if (this.isPriceLoading) return
			// Validate
			const isValid = await this.$validator.validate()
			if (!isValid) {
				this.$store.dispatch("showError", [
					"There are some missing or incorrect fields in the form"
				])
				// scroll to first error
				this.$scrollTo(
					`#${this.$validator.errors.items[0].field}`,
					300,
					{ offset: -100 }
				)
				return
			}
			// Call api to create a quote
			this.isLoading = true
			const res = await sdk.createQuote({
				payload: this.massageFormToSdk(),
				token: window.TK,
				locale: "en",
				tenantId: this.$store.state.tenantId
			})
			this.isLoading = false
			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", [
					this.$t("errors.general")
				])
				return
			}
			// Success
			// Go to quote detail page
			this.$router.push({
				name: "QuoteDetail",
				params: { id: res.policyId }
			})
		}
	},
	created() {
		// Add sicknessesSchema into form payload
		sicknessesSchema.forEach(
			item =>
				(this.form.medicalCheckup[item.id] = item.initialValue)
		)
	}
}
</script>
<style scoped>
@import "../../../assets/css/tokens.css";
.card-header {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
.asia-pricing-box-sticky {
	position: initial;
}
@media (--md) {
	.asia-pricing-box-sticky {
		position: sticky;
		top: 24px;
	}
}
</style>
